export default __webpack_public_path__ + "static/media/noBgTips.1e134a5b.svg";